import React from 'react';
import CountUp from 'react-countup';
import { useInView } from 'react-intersection-observer';

const formatNumber = (number, isPercentage) => {
  if (isPercentage) {
    return number.toFixed(0) + '%';
  }
  
  if (number >= 1_000) {
    return (number / 1_000).toFixed(0) + 'K+';
  }

  return number + '+';
};

const CountCard = ({ endValue, label, isprimary, isPercentage }) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  return (
    <div
      ref={ref}
      className={`p-6 rounded-xl flex flex-col justify-center items-center shadow-card-border transition-colors duration-300 h-28 sm:h-36 md:h-[8.5rem] lg:h-44 xl:h-52 ${
        isprimary ? 'bg-primary text-white' : 'bg-gray-200 text-primary'
      }`}
    >
      <h1 className="text-5xl sm:text-5xl md:text-4xl lg:text-5xl xl:text-6xl font-bold mb-1 text-center">
        {inView ? (
          <CountUp 
            start={1} 
            end={endValue} 
            duration={2.5} 
            formattingFn={(value) => formatNumber(value, isPercentage)}
          />
        ) : (
          formatNumber(0, isPercentage)
        )}
      </h1>
      <p className={`text-center text-sm sm:text-xs lg:text-sm ${isprimary ? 'text-white' : 'text-blue-500'}`}>{label}</p>
    </div>
  );
};

export default CountCard;
